import { LicitacionFormWizard } from "@/components/licitaciones/licitacion-form-wizard";

export default function NuevaLicitacionPage() {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold text-gray-900 mb-6">Nueva Licitación</h1>
      <LicitacionFormWizard />
    </div>
  );
}
